<template>
    <div 
        v-if="$validateText(text)" 
        ref="container"
        tabindex="-1"
        role="button"
        @blur="(e) => onBlur(e)"
    >
        <div
            v-tooltip="{
                content: text,
                trigger: 'manual',
                show: show,
                container: false,
                classes: 'text-start'
            }" 
            @click="toggleTooltip()"
        >
            <slot>
                <i class="bi bi-info-circle-fill ms-1 text-info" />  
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            show: false
        };
    },
    methods: {
        toggleTooltip() {
            this.show = !this.show;
        },
        onBlur(e) {
            if (!this.$refs.container.contains(e.relatedTarget)) {
                this.show = false;
            }
        }
    },
};
</script>